import usePrimitiveData from "src/modules/pe-landing-module/hooks/usePrimitiveData"
import { IPrimitiveProps } from "../section/Primitive"
import { IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"

/* Protopia Ecosystem component */ 
const Oval = ( props: IPrimitiveProps): JSX.Element => {
    const primitive                 = usePrimitiveData(props.primitive)
    const _position                 = usePosition(primitive) 
    const position: IScreenPosition = _position.position 

    return <div className={`primitive-${primitive.id}`} style={position.style || primitive.style}>
        <svg 
            width={ `${position!.width || 100}` }
            height={ `${position!.height || 100}` }
            xmlns="http://www.w3.org/2000/svg"
            style={{ overflow : "visible" }}
            className={ `${primitive.className} landing-primitive-svg` }
            data-primitive-type={primitive["data-primitive-type"]}
        >
            <ellipse  
                x="0" 
                y="0"
                rx={ position!.width / 2 || 50 }
                ry={ position.height / 2 || 50 }
                cx={ position.width / 2 || 50 }
                cy={ position.height / 2 || 50 }
                fill={ primitive.fill } 
                stroke={ primitive.stroke } 
                strokeWidth={ primitive.strokeWidth || 1 } 
                strokeDasharray={ primitive.strokeDasharray }
                strokeDashoffset={ primitive.strokeDashoffset }
            />
        </svg>
    </div>
}
export default Oval